<app-ngx-mat-table
  tableName="My Robots"
  description="Shows a table of all robots registered to the current user."
  dataType="robot"
  sortActive="id"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
